import { type Chapter } from '@editor2/types/chapter';
import { pick } from './pick';

export const chapterToChapterProperties = (chapter: Chapter) => {
	const properties = pick(chapter, [
		'family_id',
		'chapter_number',
		'chapter_type',
		'name',
		'image_url',
		'image_thumbnail_url',
		'image_caption',
		'image_accessibility_description',
		'notes',
		'end_of_chapter_message',
		'instructor_only'
	]);

	return properties;
};
